<ng-container *ngIf="mode == 'ReadOnly'; then read; else edit"></ng-container>
<ng-template #read>

    <div class="read-only-area" [ngSwitch]="multiple">

        <ng-container *ngSwitchCase="true">

            <ng-container *ngIf="control?.value?.length; then itemsTemplate; else notSetTemplate"></ng-container>

            <ng-template #itemsTemplate>
                <picker-item-standalone [text]="$safeNavigationMigration(item?.name)" [color]="getColor($safeNavigationMigration(item?.systemStatus))" [itemStyle]="PickerItemStyle.COLOR_LEFT" *ngFor="let item of control.value"></picker-item-standalone>
            </ng-template>

        </ng-container>

        <ng-container *ngSwitchCase="false">

            <ng-container *ngIf="control?.value; then itemTemplate; else notSetTemplate"></ng-container>

            <ng-template #itemTemplate>
                <picker-item-standalone [text]="$safeNavigationMigration(control?.value?.name)" [color]="getColor($safeNavigationMigration(control.value?.systemStatus))" [itemStyle]="PickerItemStyle.COLOR_LEFT"></picker-item-standalone>
            </ng-template>

        </ng-container>


    </div>

    <ng-template #notSetTemplate>
        <picker-item-standalone [text]="emptyText"></picker-item-standalone>
    </ng-template>

</ng-template>

<ng-template #edit>

    <ng-select [items]="data$ | async" [appendTo]="appendTo" groupBy="systemStatus" [groupValue]="getGroup" [selectableGroup]="selectableGroup" bindLabel="name" [placeholder]="placeholder" [hideSelected]="hideSelected" [compareWith]="compareFn" [searchFn]="searchFn" [multiple]="multiple" [searchable]="true" [formControl]="control" [clearable]="allowClear">
        <ng-template ng-option-tmp let-item="item">
            <picker-item-standalone [text]="item?.name ?? emptyText" [color]="getColor($safeNavigationMigration(item?.systemStatus))" [itemStyle]="PickerItemStyle.COLOR_LEFT"></picker-item-standalone>
        </ng-template>

        <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <picker-item-standalone [text]="item?.name ?? emptyText" [color]="getColor($safeNavigationMigration(item?.systemStatus))" [itemStyle]="PickerItemStyle.COLOR_LEFT" [clearable]="multiple === true" (clear)="clear(item)"></picker-item-standalone>
        </ng-template>

    </ng-select>

</ng-template>